module.exports = __webpack_public_path__ + "img/Mask Group 2917@2x.da6097a7.png";